import './style.scss';

const isTablet = window.innerWidth < 1024;
class Popup {
  constructor({
    targetPage = null,
    storage = 'localStorage',
    hideForExistsUsers = false,
    random = false,
    template = '',
    gaEventName = 'PopupBanner',
    gaEventLabel = null,
    bannerName = null,
    container = null,
    analytics = {
      type: 'ga',
    },
  }) {
    this.targetPage = targetPage;
    this.gaEventLabel = gaEventLabel;
    this.containerPopup = document.createElement('div');
    this.storage = storage;
    this.hideForExistsUsers = hideForExistsUsers;
    this.random = random;
    this.template = template;
    this.content = document.createElement('div');
    this.overlay = document.createElement('div');
    this.closeBtn = document.createElement('span');
    this.gaEventName = gaEventName;
    this.container = container ? document.querySelector(container) : document.documentElement;
    this.bannerName = bannerName;
    this.analytics = { enable: true, ...analytics };
  }

  init() {
    if (!this.bannerName && this.bannerName === '') throw new Error('bannerName is empty!');
    if (!isTablet) {
      this.containerPopup.classList.add('Popup');
      this.containerPopup.classList.add(this.bannerName);
      this.containerPopup.classList.add('Popup--hidden');
      this.content.classList.add('Popup__content');
      this.overlay.classList.add('Popup__overlay');

      if (this.random && Array.isArray(this.template)) {
        const randIndx = Math.floor(Math.random() * (this.template.length - 1 + 1));

        const template = document.createElement('div');
        template.innerHTML = this.template[randIndx].trim();
        const gaTemplateLabel = template.querySelector('[data-banner-btn]');

        if (gaTemplateLabel) {
          this.gaEventLabel = gaTemplateLabel.dataset.gaLabel || null;
        }

        this.content.innerHTML = this.template[randIndx];
      } else {
        this.content.innerHTML = Array.isArray(this.template) ? this.template[0] : this.template;
        this.gaEventLabel = this.gaEventLabel || null;
      }

      this.content.appendChild(this.closeBtn);
      this.closeBtn.classList.add('Popup__close');
      this.closeBtn.setAttribute('data-exit-popup-close', '');
      this.containerPopup.appendChild(this.content);
      this.containerPopup.appendChild(this.overlay);
      this.container.appendChild(this.containerPopup);

      if (!sessionStorage.getItem('popupShow')) {
        this.open();
      }

      const closeNodes = this.container.querySelectorAll('[data-exit-popup-close]');
      if (closeNodes) {
        [...closeNodes].forEach((el) => el.addEventListener('click', () => {
          this.close();
        }));
      }

      this.overlay.addEventListener('click', () => {
        this.close();
      });

      this.containerPopup.querySelector('.what-we-do__links__item--stem')
        .addEventListener('click', () => {
          this.sendEvent('STEM click', this.gaEventLabel, '1');
        });

      this.containerPopup.querySelector('.what-we-do__links__item--writing')
        .addEventListener('click', () => {
          this.sendEvent('Writing click', this.gaEventLabel, '1');
        });
    }
  }

  sendEvent(eventAction, eventLabel, eventValue) {
    if (this.analytics.enable) {
      if (this.analytics.type === 'gtag' && typeof window.gtag === 'function') {
        // eslint-disable-next-line no-undef
        gtag('event', eventAction, {
          event_category: this.gaEventName,
          event_label: eventLabel || eventValue,
          value: eventValue,
        });
      } else if (this.analytics.type === 'ga' && typeof window.ga === 'function') {
        // eslint-disable-next-line no-undef
        ga('send', 'event', this.gaEventName, eventAction, eventLabel || eventValue, eventValue);
      }
    }
  }

  close() {
    this.containerPopup.classList.remove('Popup--visible');
    this.containerPopup.classList.add('Popup--hidden');
    this.sendEvent('Close Popup', this.gaEventLabel, '1');
  }

  open() {
    this.containerPopup.classList.remove('Popup--hidden');
    this.containerPopup.classList.add('Popup--visible');
    this.sendEvent('Show Popup', this.gaEventLabel, '1');
    sessionStorage.setItem('popupShow', true);
  }
}

export default Popup;
